import { render, staticRenderFns } from "./workOrderInfo.vue?vue&type=template&id=2f41f83f&scoped=true"
import script from "./workOrderInfo.vue?vue&type=script&lang=js"
export * from "./workOrderInfo.vue?vue&type=script&lang=js"
import style0 from "./workOrderInfo.vue?vue&type=style&index=0&id=2f41f83f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f41f83f",
  null
  
)

export default component.exports